<section class="partners-header">
    <app-header
        [title]="'partners.title' | translate"
    />
</section>

<section class="content">
    <section class="partners-form">
        <section class="partners-intro">
            <p>{{ 'partners.subtitle' | translate }}</p>
        </section>    

        <section class="partners-filters">
            <p>{{ 'partners.filter-title' | translate }}</p>
            <div class="divider"></div>
            <form class="partners-filters-form" (ngSubmit)="onSearch()">
                <div class="form-group">
                    <label for="type">{{ 'partners.filter-type' | translate }}</label>
                    <div class="custom-select" [class.empty]="!selectedTypeObject?.value">
                        <app-select
                            [placeholder]="'my_displays.choice_one' | translate"
                            [options]="typeOptions"
                            [required]="true"
                            [isClearable]="false"
                            [searchable]="false"
                            [selectedValue]="selectedTypeObject"
                            (selectedValueChanged)="onTypeChange($event)"
                        />
                    </div>
                </div>

                <div *ngIf="userInfo" class="form-group postal-autocomplete">
                    <label for="postal">{{ 'partners.filter-zip-code' | translate }}</label>
                    <app-select-postal
                        [userInfo]="userInfo"
                        [disabled]="false"
                        (postalSelected)="onPostalSelected($event)"
                    ></app-select-postal>
                </div>

                <button type="submit"
                        [disabled]="!selectedTypeObject || !postal || !isPostalValid"
                        [ngClass]="{ 'active': selectedTypeObject && postal && isPostalValid }">
                        {{ 'partners.search-button' | translate }}
                </button>
            </form>

            <div class="partners-results desktop-only">
                <span>
                    {{ 'partners.results' | translate }}: 
                    <span class="results-count">{{ resultsCount }}</span>
                </span>
                <span class="partners-contact">
                    {{ 'partners.no-results' | translate }}
                    <a class="cursor-pointer" (click)="goToSalesSupport()">{{ 'partners.contact-advisor' | translate }}</a>
                </span>
            </div>
            <section class="partners-empty" *ngIf="!hasSearched">
                <p>{{ 'partners.choose-start' | translate }}</p>
            </section>
            <section class="partners-results-table" *ngIf="hasSearched">
                <app-table
                    *ngIf="hasSearched"
                    [data]="results"
                    [columns]="tableColumns"
                    [rowActions]="rowActions"
                    [noDataMessage]="'partners.no-results'"
                    [selectable]="false"
                    (actionClicked)="onContactClick($event)">
                </app-table>
            </section>
            <div class="partners-results tablet-only">
                <span>
                    {{ 'partners.results' | translate }}: 
                    <span class="results-count">{{ resultsCount }}</span>
                </span>
                <span class="partners-contact">
                    {{ 'partners.no-results' | translate }}
                    <a class="cursor-pointer" (click)="goToSalesSupport()">{{ 'partners.contact-advisor' | translate }}</a>
                </span>
            </div>
        </section>

        <section class="partners-info">
            <section class="partners-info-content">
                <div class="title">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.5 16.5H12.5V11H11.5V16.5ZM12 9.575C12.1667 9.575 12.3127 9.51667 12.438 9.4C12.5627 9.28333 12.625 9.13333 12.625 8.95C12.625 8.78333 12.5627 8.64167 12.438 8.525C12.3127 8.40833 12.1667 8.35 12 8.35C11.8333 8.35 11.6873 8.40833 11.562 8.525C11.4373 8.64167 11.375 8.78333 11.375 8.95C11.375 9.13333 11.4373 9.28333 11.562 9.4C11.6873 9.51667 11.8333 9.575 12 9.575ZM12 21C10.75 21 9.57933 20.7627 8.488 20.288C7.396 19.8127 6.446 19.1707 5.638 18.362C4.82933 17.554 4.18733 16.604 3.712 15.512C3.23733 14.4207 3 13.25 3 12C3 10.75 3.23733 9.579 3.712 8.487C4.18733 7.39567 4.82933 6.44567 5.638 5.637C6.446 4.829 7.396 4.18733 8.488 3.712C9.57933 3.23733 10.75 3 12 3C13.25 3 14.421 3.23733 15.513 3.712C16.6043 4.18733 17.5543 4.829 18.363 5.637C19.171 6.44567 19.8127 7.39567 20.288 8.487C20.7627 9.579 21 10.75 21 12C21 13.25 20.7627 14.4207 20.288 15.512C19.8127 16.604 19.171 17.554 18.363 18.362C17.5543 19.1707 16.6043 19.8127 15.513 20.288C14.421 20.7627 13.25 21 12 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#365BCA"/>
                    </svg>
                    <p>{{ 'partners.info-title' | translate }}</p>
                </div>
                <p class="description">{{ 'partners.info-description' | translate }}</p>
                <div class="button" [attr.gtm-label]="'link_learn-more-about-partners'">
                    <a href="#" (click)="$event.preventDefault(); onOpenDisclaimer()">{{ 'partners.info-button' | translate }}</a>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.4002 17.3L8.7002 16.6L13.3002 12L8.7002 7.39995L9.4002 6.69995L14.7002 12L9.4002 17.3Z" fill="#365BCA"/>
                    </svg>
                </div>               
            </section>           
        </section> 
    </section>
</section>

<app-partners-recommended-modal
  [(open)]="disclaimerOpen"
  (confirmed)="onDisclaimerConfirmed()">
</app-partners-recommended-modal>

<app-partners-contact-modal
  *ngIf="selectedPartner"
  [partner]="selectedPartner"
  (close)="selectedPartner = null">
</app-partners-contact-modal>